var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8286 0H11.3185H2.53668H2.04037C0.923682 0 0.0137863 0.917176 0 2.0428V22.9572C0 24.0828 0.909896 25 2.02659 25H11.8149C12.9315 25 13.8414 24.0828 13.8414 22.9572V2.0428C13.8552 0.917176 12.9453 0 11.8286 0ZM3.36386 0.833797H10.4914V0.958866C10.4914 1.27849 10.2294 1.54252 9.91235 1.54252H3.94288C3.6258 1.54252 3.36386 1.27849 3.36386 0.958866V0.833797ZM11.8286 24.1801C12.4904 24.1801 13.028 23.6381 13.028 22.9711V2.0428C13.028 1.37576 12.4904 0.833797 11.8286 0.833797H11.3185V0.958866C11.3185 1.73708 10.6844 2.37632 9.91235 2.37632H3.94288C3.17085 2.37632 2.53668 1.73708 2.53668 0.958866V0.833797H2.04037C1.37863 0.833797 0.840964 1.37576 0.840964 2.0428V22.9711C0.840964 23.6381 1.37863 24.1801 2.04037 24.1801H11.8286Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.119 22.6793H3.25343C3.01907 22.6793 2.83984 22.86 2.83984 23.0962C2.83984 23.3325 3.01907 23.5131 3.25343 23.5131H10.119C10.3534 23.5131 10.5326 23.3325 10.5326 23.0962C10.5326 22.86 10.3534 22.6793 10.119 22.6793Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPhone);
export default __webpack_public_path__ + "static/media/cell-phone.bba95c25bb7677ba7e9564736358db40.svg";
export { ForwardRef as ReactComponent };